var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCocktail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72527 1C1.32472 1 1 1.32798 1 1.73256C1 2.13714 1.32472 2.46512 1.72527 2.46512H4.33651C4.81421 2.46512 5.2471 2.74927 5.44112 3.19018L5.44441 3.19767H7.03178L6.76665 2.59514C6.33982 1.62513 5.38745 1 4.33651 1H1.72527Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1319 9.05814C18.9752 9.05814 18.8207 9.04873 18.6689 9.03045L20.0989 7.10465C21.2942 5.49489 20.157 3.19767 18.1648 3.19767H15.7812C16.45 2.02988 17.7001 1.24419 19.1319 1.24419C21.2682 1.24419 23 2.9934 23 5.15116C23 7.30893 21.2682 9.05814 19.1319 9.05814Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4945 20.5349C8.09394 20.5349 7.76922 20.8629 7.76922 21.2674C7.76922 21.672 8.09394 22 8.4945 22H14.2967C14.6973 22 15.022 21.672 15.022 21.2674C15.022 20.8629 14.6973 20.5349 14.2967 20.5349H12.1209V15.407L14.7379 11.8826C13.3812 11.9741 12.0161 11.7583 10.7443 11.2445C9.6128 10.7873 8.39517 10.6113 7.19263 10.7235L10.6703 15.407V20.5349H8.4945Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62639 4.66279H18.1648C18.9617 4.66279 19.4166 5.58168 18.9385 6.22558L15.9733 10.2189L15.6334 10.2876C14.1752 10.5821 12.6637 10.442 11.2831 9.88414C9.6669 9.23119 7.90303 9.06057 6.19995 9.38659L3.85276 6.22558C3.37463 5.58168 3.82951 4.66279 4.62639 4.66279Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktail);
export default __webpack_public_path__ + "static/media/cocktail.62e7e7ebeef153b5d976e833cd67f7ce.svg";
export { ForwardRef as ReactComponent };